import React from 'react';
import ReactDOM from 'react-dom/client';
import 'normalize.css';
import '@fontsource/rubik/400';
import '@fontsource/rubik/600';
import '@fontsource/poppins/400';
import '@fontsource/poppins/600';
import '@fontsource/poppins/700';

import GlobalStyles from './src/static/styles/global.css';

export const wrapPageElement = ({ element }) => (
  <>
    <GlobalStyles />
    {element}
  </>
);

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};
